import styled, { css } from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';
import DialogStyle from 'components/Dialog/styles';
import { DEEP_BORDER_BOX } from 'common';

export default {
  ContentContainer: styled.div`
    ${props => css`height: ${props.$appBanner ? `calc(100% - ${props.$appBanner}px)` : '100%'};`}
    ${({ $appBanner }) =>
    $appBanner &&
    css`
      margin-top: ${$appBanner}px;
    `}
    width: 100%;
    display: flex;
    flex-direction: column;
    ${DialogStyle.Title} {
      padding: ${Tokens.SPACING.SPACING_24};
    }
  `,
  AnimationContainer: styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  `,
  DialogSheetOverlay: styled.div`
    ${DEEP_BORDER_BOX}  
    height: 100vh;
    width: 100vw;
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    ${({ $overlay }) =>
    $overlay &&
    css`
      background: ${$overlay.backgroundColor};
    `}
  `
};
